export default function hardcodedMetaDataProvider(type, imageId, imageIds) {
  // Cornerstone fires metaData.get with no/undefined imageId during some
  // internal lookups (and during setStack with the multi-frame fix's
  // earlier-firing render path). Bail cleanly when there's no string to
  // parse — this provider only answers for the `web:` scheme.
  if (typeof imageId !== "string") return undefined;
  const colonIndex = imageId.indexOf(":");
  const scheme = imageId.substring(0, colonIndex);
  if (scheme !== "web") return;

  if (type === "imagePixelModule") {
    const imagePixelModule = {
      pixelRepresentation: 0,
      bitsAllocated: 24,
      bitsStored: 24,
      highBit: 24,
      photometricInterpretation: "RGB",
      samplesPerPixel: 3,
    };

    return imagePixelModule;
  } else if (type === "generalSeriesModule") {
    const generalSeriesModule = {
      modality: "SC",
      seriesNumber: 1,
      seriesDescription: "Color",
      seriesDate: "20190201",
      seriesTime: "120000",
      seriesInstanceUID: "1.2.276.0.7230010.3.1.4.83233.20190201120000.1",
    };

    return generalSeriesModule;
  } else if (type === "imagePlaneModule") {
    const index = Array.isArray(imageIds) ? imageIds.indexOf(imageId) : 0;
    const imagePlaneModule = {
      imageOrientationPatient: [1, 0, 0, 0, 1, 0],
      imagePositionPatient: [0, 0, index * 5],
      pixelSpacing: [1, 1],
      columnPixelSpacing: 1,
      rowPixelSpacing: 1,
      frameOfReferenceUID: "FORUID",
      columns: 768,
      rows: 768,
      rowCosines: [1, 0, 0],
      columnCosines: [0, 1, 0],
    };

    return imagePlaneModule;
  } else if (type === "voiLutModule") {
    return {
      windowWidth: [255],
      windowCenter: [128],
    };
  } else if (type === "modalityLutModule") {
    return {
      rescaleSlope: 1,
      rescaleIntercept: 0,
    };
  } else {
    return undefined;
  }
}
